import { createSelector } from 'reselect'

import { getCategories } from 'partner360/features/landing/selectors/getCategories'

import { selectLandingState } from './selectLandingState'

export const selectLandingCategories = createSelector(
  [selectLandingState],
  ({ processedPlannings, selectedPlanning }) => {
    const categories = getCategories({
      selectedPlanningId: selectedPlanning.PlanningId,
      processedPlannings,
    })

    const allCategoriesForPlanning = selectedPlanning.AllCategories.map(
      (category) => category.Category
    )

    return allCategoriesForPlanning.filter((el) => categories.includes(el))
  }
)
